import classNames from 'classnames'
import Icon from '../assets'

const ButtonControl = (props) => {
  let {
    class: customClass = '',
    disabled = false,
    fullWidth = false,
    icon = '',
    onClick = undefined,
    title = null,
    variant = '',
    isLoading = false,
    newStyle = false,
    outlined = false,
    type = 'button',
    size = 'small'
  } = props
  let baseClass = 'button-control'
  if (newStyle) baseClass = `${baseClass}-new`
  const classes = classNames(
    baseClass,
    variant ? `${baseClass}--${variant}${outlined ? '--outlined' : ''}` : `${baseClass}--secondary`,
    fullWidth && `${baseClass}--full-width`,
    icon && `${baseClass}--icon`,
    newStyle && size && `${baseClass}--${size}`,
    customClass
  )

  if (!icon && !title) return null

  if (typeof onClick === 'string' && onClick !== '') {
    const onClickSelector = onClick
    onClick = () => window && window.document.getElementById(onClickSelector).click()
  }

  type = type || 'button'

  return (
    <button
      className={classes}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {isLoading
        ? <div>
          <Icon icon='loader' />
          <span className='button-control__title--hide'>{title}</span>
        </div>
        : <div>
          {icon && <Icon icon={icon} size={16} />}
          {title}
        </div>}
    </button>
  )
}

export default ButtonControl
